/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiPriceList, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of PriceListsController.
 */
export class PriceListsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /price_lists:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiPriceList>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiPriceList>>>('/price_lists:query', query);
    }

    /**
     * Calls POST /price_lists:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiPriceList>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiPriceList>>, ListRequest>('/price_lists:query', listRequest, query);
    }

    /**
     * Calls POST /price_lists:prefill
     */
    public createPrefilled(): Promise<Result<ApiPriceList>> {
        return this.http.post<Result<ApiPriceList>, undefined>('/price_lists:prefill', undefined);
    }

    /**
     * Calls POST /price_lists/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiPriceList>>> {
        return this.http.post<Result<LockedContextDto<ApiPriceList>>, undefined>(`/price_lists/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /price_lists/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiPriceList>> {
        return this.http.post<Result<ApiPriceList>, undefined>(`/price_lists/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /price_lists/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiPriceList[]>> {
        return this.http.post<Result<ApiPriceList[]>, string[]>('/price_lists/locks', ids);
    }

    /**
     * Calls POST /price_lists/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/price_lists/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /price_lists/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/price_lists/${primaryId}/locks`);
    }

    /**
     * Calls GET /price_lists/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiPriceList>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiPriceList>>(`/price_lists/${primaryId}`, query);
    }

    /**
     * Calls POST /price_lists
     */
    public add(dto: ApiPriceList): Promise<Result<ApiPriceList>> {
        return this.http.post<Result<ApiPriceList>, ApiPriceList>('/price_lists', dto);
    }

    /**
     * Calls PUT /price_lists/{primaryId}
     */
    public update(dto: ApiPriceList, primaryId: string): Promise<Result<ApiPriceList>> {
        return this.http.put<Result<ApiPriceList>, ApiPriceList>(`/price_lists/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /price_lists
     */
    public putRange(dtos: ApiPriceList[]): Promise<Result<ApiPriceList[]>> {
        return this.http.patch<Result<ApiPriceList[]>, ApiPriceList[]>('/price_lists', dtos);
    }

    /**
     * Calls DELETE /price_lists/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/price_lists/${primaryId}`);
    }

    /**
     * Calls POST /pricelists:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiPriceList>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiPriceList>>, ListRequestWithIds>('/pricelists:batch', listRequest, query);
    }
}
